import axios from 'axios';
import {OrderStatus} from '../../interfaces/order';
import {findSystemById, saveDataToLocalStorage} from '../../common/tools/resource';
import {NotFoundError} from '../../common/tools/httpError';

const getOrderDetails = async (orderId: string) => {
    let system = findSystemById(orderId, 'orders');

    if (!system) {
        await getOrdersByClient(null);
        system = findSystemById(orderId, 'orders');
        if (!system) {
            throw new NotFoundError();
        }
    }

    const response = await axios.get(`/api/orders/${system}/${orderId}`);

    return response.data;
};

const getOrdersByClient = async (status: OrderStatus | null) => {
    const resourceName = 'orders';
    const response = await axios.get('/api/orders', {
        params: {status: status},
    });
    saveDataToLocalStorage(response.data, resourceName);

    return response.data;
};

const getOrderMessages = async (orderId: string, statusLabel?: string) => {
    const system = findSystemById(orderId, 'orders');
    const response = await axios.get(
        `/api/orders/${system}/${orderId}/messages${
            statusLabel !== undefined ? `?statusEC=${statusLabel}` : ''
        }`
    );

    return response.data;
};

const getCollectInfos = async (idBu: string) => {
    const response = await axios.get(`/api/orders/${idBu}/`);
    return response.data;
};

export {getOrderDetails, getOrdersByClient, getOrderMessages, getCollectInfos};
